export default "__VITE_ASSET__DWJ4Kvgu__"